/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Channelinboxunread2Inputs */

const en_channelinboxunread2 = /** @type {(inputs: Channelinboxunread2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} new`)
};

const de_channelinboxunread2 = /** @type {(inputs: Channelinboxunread2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} neu`)
};

/**
* | output |
* | --- |
* | "{count} new" |
*
* @param {Channelinboxunread2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelinboxunread2 = /** @type {((inputs: Channelinboxunread2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelinboxunread2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelinboxunread2(inputs)
	return de_channelinboxunread2(inputs)
});
export { channelinboxunread2 as "channelInboxUnread" }